import React, { createContext, useContext, useState, useCallback } from "react";

const OrderCtx = createContext({ open: false, openOrder: () => {}, closeOrder: () => {} });

export const OrderProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openOrder = useCallback(() => setOpen(true), []);
  const closeOrder = useCallback(() => setOpen(false), []);
  return (
    <OrderCtx.Provider value={{ open, openOrder, closeOrder, setOpen }}>
      {children}
    </OrderCtx.Provider>
  );
};

export const useOrder = () => useContext(OrderCtx);
